function careerRecruitmentSlider() {
  [
    ...document.querySelectorAll(".slider-wrapper--career-recruitment"),
  ]?.forEach((slider) => {
    new Splide(slider, {
      speed: 1000,
      perPage: 1,
      perMove: 1,
      lazyload: "sequential",
      mediaQuery: "min",
      breakpoints: {
        782: {
          perPage: 3,
          perMove: 3
        },
      },
    }).mount();

    // Count slider elements and add class for desktop
    let sliderItems = slider.querySelectorAll('.splide__slide').length;

    if ( sliderItems <= 3 ) {
      slider.classList.add('slider-wrapper--career-recruitment--alternative');
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  careerRecruitmentSlider();
});
